import * as tslib_1 from "tslib";
import React, { useState, useMemo } from 'react';
import _ from 'lodash';
import { TextboxField } from '../';
import { formatNumber, parseNumber } from '../../../utilities';
export const getCurrencyType = (locale) => {
    // for now only supporting USD
    switch (locale) {
        default:
            return 'USD';
    }
};
export const CurrencyField = (_a) => {
    var { type, step, value, locale } = _a, props = tslib_1.__rest(_a, ["type", "step", "value", "locale"]);
    const { id, form } = props;
    const { values, handleBlur, setValues } = form;
    const [hasFocus, setHasFocus] = useState(false);
    const currency = useMemo(() => getCurrencyType(locale), [locale]);
    const formattedValue = useMemo(() => {
        const currencyValue = value || _.get(values, id);
        // format value as currency
        return _.isNumber(currencyValue) || currencyValue
            ? formatNumber(currencyValue, { locale, currency })
            : formatNumber(0, { locale, currency });
    }, [id, value, values, locale, currency]);
    const overrideProps = useMemo(() => {
        // use inputMode="decimal" instead of type="number" (so user can still enter delimiters like comma)
        if (hasFocus) {
            return {
                inputMode: 'decimal',
            };
        }
        return {
            value: formattedValue,
        };
    }, [hasFocus, formattedValue]);
    const onFocus = () => {
        // when focusing, set form value to formatted currency value
        setValues(_.set(Object.assign({}, values), id, formattedValue));
        setHasFocus(true);
    };
    const parseValue = (numString) => {
        const parsedValue = numString && parseNumber(numString, locale);
        return parsedValue ? _.round(parsedValue, 2) : parsedValue;
    };
    const onBlur = (e) => {
        // when blurring, round to 2 decimal places and set form value
        let roundedValue = parseValue(e.target.value);
        if (isNaN(roundedValue))
            roundedValue = 0;
        setValues(_.set(Object.assign({}, values), id, roundedValue));
        setHasFocus(false);
        handleBlur(e);
    };
    const onKeyDown = (event) => {
        event.persist();
        if (event.key === 'Enter') {
            const roundedValue = parseValue(event.target.value);
            setValues(_.set(Object.assign({}, values), id, roundedValue));
            setHasFocus(false);
            event.target.blur();
        }
    };
    return React.createElement(TextboxField, Object.assign({}, props, overrideProps, { onfocus: onFocus, onblur: onBlur, onKeyDown: onKeyDown }));
};
//# sourceMappingURL=Currency.js.map